<template>
  <div class="wrap">
    <!-- browser-suggestion -->
    <browser-suggestion></browser-suggestion>
    <!-- browser-suggestion -->

    <div class="wrapper">
      <!-- curr-banner -->
      <banners class="curr-banner"></banners>
      <!-- /curr-banner -->

      <!-- 详情内容 -->
      <div class="page-detail">
        <!-- layer背景氛围层 -->
        <div class="bg-atmosphere-layer">
          <div class="page-title">
            <a class="title"
              >{{
                internalListData.zpfs == "" || !internalListData.zpfs
                  ? "内部招聘"
                  : internalListData.zpfs
              }}
            </a>
            <!-- btn-group -->
            <div class="btn-group">
              <el-button
                type="primary"
                class="apply-btn"
                @click="applyBtn(true, internalListData.zpfs)"
              >
                <!-- <i class="el-icon-edit-outline"></i>  -->
                申请</el-button
              >
              <el-button type="warning" class="back-btn" @click="backBtn">
                <!-- <i class="el-icon-back"></i> -->
                返回</el-button
              >
            </div>
            <!-- btn-group -->
          </div>
          <div class="campus-cont">
            <div class="title">
              <p>{{ internalListData.zpgw }}</p>
            </div>
            <div class="info-wrap">
              <div class="person">
                {{ internalListData.gzdd }} 招聘人数：{{
                  internalListData.zprs
                }}
              </div>
              <div class="date">报名截止日期：{{ internalListData.jzrq }}</div>
            </div>
            <div class="foot">
              <span>{{ internalListData.xl }}</span> |
              <span>{{ internalListData.zy }}</span>
            </div>
          </div>
        </div>
        <!-- layer背景氛围层 -->

        <div class="page-body">
          <div class="body-row body-item-wrap">
            <div class="row-title">
              <a>岗位基本信息</a>
            </div>
            <div class="row-body">
              <div class="row">
                <div class="left">招聘单位：{{ internalListData.zpdw }}</div>
                <div class="right">
                  招聘人数：{{ internalListData.zprs }} 人
                </div>
              </div>
              <div class="row">
                <div class="left">招聘部门：{{ internalListData.zpbm }}</div>
                <div class="right">用工形式：{{ internalListData.ygxs }}</div>
              </div>
              <div class="row">
                <div class="left">招聘岗位：{{ internalListData.zpgw }}</div>
                <div class="right">工作地点：{{ internalListData.gzdd }}</div>
              </div>
              <div class="row">
                <div class="single">备注：{{ internalListData.bz }}</div>
              </div>
            </div>
          </div>

          <div class="body-row body-item-wrap">
            <div class="row-title">
              <a>岗位要求</a>
            </div>
            <div class="row-body">
              <div class="row">
                <div class="left">年龄：{{ internalListData.age }}</div>
                <div class="right">学历：{{ internalListData.xl }}</div>
              </div>
              <div class="row">
                <div class="left">学位：{{ internalListData.xw }}</div>
                <div class="right">专业：{{ internalListData.zy }}</div>
              </div>
              <div class="row">
                <div class="single">
                  最低服务年限：<span>{{ internalListData.zdfwnx }}</span>
                </div>
              </div>
              <div class="row">
                <div class="single">
                  专业职称/技术等级/职业资格：<span>{{
                    internalListData.zc
                  }}</span>
                </div>
              </div>
              <div class="row">
                <div class="single">
                  工作经验及其他要求：{{ internalListData.gzjy }}
                </div>
              </div>
            </div>
          </div>

          <div class="body-row body-item-wrap">
            <div class="row-title">
              <a>岗位职责</a>
            </div>
            <div class="row-body">
              <div class="row">
                <div class="single">
                  {{ internalListData.gwzz }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <resume
				:resumeFlag="resumeFlag"
				v-if="resumeFlag.flag"
				:backRoute="resumeBackRoute"
			></resume> -->
      <resume-list
        :resumeFlag="resumeFlag"
        v-if="resumeFlag.flag"
        :backRoute="resumeBackRoute"
      ></resume-list>
    </div>
  </div>
</template>

<script>
// import searchs from '../../common/search'
import banners from "../../common/banner";
// import resume from "../../common/resume";
import resumeList from "../../common/resumelist";
import { campusData } from "../../request/api";
import { mapMutations } from "vuex";
import { MessageBox } from "element-ui";
import { isLogin, getLoginUser } from "../../../utils/auth";
export default {
  components: {
    // searchs,
    banners,
    resumeList,
  },
  name: "home",
  data() {
    return {
      // 返回路由
      resumeBackRoute: {},
      resumeFlag: {
        flag: false,
      }, //简历弹窗
      internalListData: {},
      userInfo: {},
      // 岗位信息 从全局store中取
      // SelectData: {
      //   postoid:'',
      //   postname: '',
      //   orgname: ''
      // }
    };
  },
  mounted() {
    // console.log(this.$route.query.oid)
    this.initData(this.$route.query.oid);

    // if (this.$route.query.postoid && this.$route.query.postoid != "") {
    //   // 设置数据
    //   this.setResumeSelectData({
    //     oid: this.$route.query.postoid,
    //     postoid: this.$route.query.postoid,
    //     postname: this.$route.query.postname,
    //     orgname: this.$route.query.orgname,
    //   });
    // }

    // this.$router.push(`/internalList?oid=${postoid}&postoid=${postoid}&orgname=${orgname}&postname=${postname}`);

    // 设置返回路由
    this.resumeBackRoute = {
      path: `/internalList?oid=${this.$route.query.oid}`,
    };

    this.$nextTick(() => {
      // dom元素更新后执行，因此这里能正确打印更改之后的值
      if (
        document.getElementsByClassName("main-scroll") &&
        document.getElementsByClassName("main-scroll")[0]
      ) {
        document.getElementsByClassName("main-scroll")[0].scrollTo(0, 0);
      }
    });
  },
  methods: {
    ...mapMutations([
      // 全局职业选择
      "setResumeSelectData",
    ]),
    initData(oid) {
      let data = {
        oid: oid,
      };
      campusData(data).then((response) => {
        this.internalListData = response.data;
      });
    },
    applyBtn(flag, zpfs) {
      if (!isLogin()) {
        this.$router.push("/login");
        return;
      }
      this.userInfo = getLoginUser();
      //判断当前岗位是否是内部招聘
      if (zpfs.indexOf("内部招聘") != -1) {
        //如果是内部招聘，需要判断是否已进行身份认证
        if (this.userInfo.hrpsn == "" || this.userInfo.hrpsn <= 0) {
          MessageBox.confirm("当前职位为内部招聘，请先进行身份认证。", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            this.$router.push("/auth");
          });
          return;
        }
      }
      // 设置数据
      this.setResumeSelectData({
        oid: this.$route.query.oid,
        postoid: this.$route.query.oid,
        postname: this.internalListData.zpgw,
        orgname: this.internalListData.zpdw,
      });
      // 判断用户是否登录
      this.resumeFlag.flag = true;
    },
    backBtn() {
      // 返回按钮
      //   this.$router.go(-1);
      this.$router.push("/internal");
    },
  },
  // computed: {
  //   SelectData: function () {
  //     return this.$store.state.resumeSelectData;
  //   },
  // },
};
</script>

<style lang="scss" scoped>
// page-detail
.wrap {
  .wrapper {
    width: auto;
    padding-left: 24px;
    padding-right: 24px;
    padding-top: 20px;
    padding-bottom: 24px;
    margin-bottom: 40px;
    margin: 0 auto;
    min-width: 320px;

    // curr-banner
    .curr-banner {
      margin-bottom: 24px;
      height: 128px;

      ::v-deep {
        .el-carousel .img-item {
          display: block;
          height: 128px;
          width: 100%;
        }

        .el-carousel__button {
          width: 12px;
        }

        .el-carousel .el-carousel__container {
          height: 128px;
        }
      }
    }

    // curr-banner

    // .page-detail
    .page-detail {
      // border-bottom-left-radius: 24px;
      // border-bottom-right-radius: 24px;
      background: #fff;

      .bg-atmosphere-layer {
        // margin-top: -40px;
        // padding-top: 52px;
        // padding-bottom: 200px;
        // border-bottom-left-radius: 50%;
        // border-bottom-right-radius: 50%;
        // background: linear-gradient(to bottom,#4bc0eb, #CCC);
        z-index: 15;
      }

      .page-title {
        height: 48px;
        line-height: 48px;
        background: transparent;
        // border-bottom: 1px solid #eee;
        position: relative;
        z-index: 11;

        .title {
          position: relative;
          font-size: 18px;
          text-decoration: none;
          // color: #fff;
          color: rgba(0, 0, 0, 0.8);
          // color: rgba(255, 255, 255, .8);
          margin-left: 16px;
        }

        .title::after {
          position: absolute;
          left: -8px;
          top: 0;
          bottom: 0;
          content: "";
          width: 4px;
          background: #0089d0;
        }
      }

      .btn-group {
        position: absolute;
        right: 12px;
        top: 12px;
        line-height: 1.5;

        .back-btn,
        .apply-btn {
          padding: 8px 12px;
          border-radius: 0;
        }

        .apply-btn {
          display: none;
        }

        .apply-btn {
          // background: linear-gradient(to right, #ffa39e, #f5222d);
          border: none;
          color: rgba(255, 255, 255, 0.8);

          &:hover {
            // background: linear-gradient(to left, #ffa39e, #f5222d);
          }

          &:active {
            opacity: 0.5;
          }
        }

        .back-btn {
          // background: linear-gradient(to right, #91d5ff, #1890ff);
          border: none;
          color: rgba(255, 255, 255, 0.8);

          &:hover {
            // background: linear-gradient(to left, #91d5ff, #1890ff);
          }

          &:active {
            opacity: 0.5;
          }
        }
      }

      // campus-cont
      .campus-cont {
        position: relative;
        padding: 12px;
        background: transparent;
        padding-bottom: 40px;

        .title {
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 20px;
          height: 140px;
          width: 140px;
          text-align: center;
          border-radius: 50%;
          background: #edf1f7;
          // background-image: radial-gradient(circle, #77d9f7, #ff7875);
          vertical-align: middle;
          // color: rgba(255, 0, 0, .8);

          display: flex;
          justify-content: center; /**水平居中*/
          align-items: center; /**垂直居中*/

          p {
            line-height: 22px;
            margin: 0;
          }
        }

        .info-wrap {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          line-height: 40px;
          font-size: 16px;
          // color: rgba(255, 255, 255, 0.8);
          .person,
          .date {
            flex: 0 0 auto;
            width: 100%;
            margin-bottom: 12px;
          }
        }

        .foot {
          // color: rgba(255, 255, 255, 0.8);
          margin-bottom: 12px;
        }
      }

      // .page-body
      .page-body {
        padding-bottom: 40px;
        z-index: 10;
        // margin-top: -200px;

        // campus-cont

        // body-row
        .body-row {
          .row {
          }
        }

        .body-item-wrap {
          background: #edf1f7;
          margin-bottom: 20px;
          margin-left: 12px;
          margin-right: 12px;
          // border-radius: 20px;
          z-index: 11;
        }

        .row-title {
          height: 40px;
          line-height: 40px;
          background: transparent;
          // border-bottom: 1px solid #eee;

          a {
            position: relative;
            font-size: 18px;
            text-decoration: none;
            color: #000;
            color: rgba(0, 0, 0, 0.8);
            margin-left: 16px;
          }

          a::after {
            position: absolute;
            left: -8px;
            top: 0;
            bottom: 0;
            content: "";
            width: 4px;
            background: #0089d0;
          }
        }

        .row-body {
          font-size: 14px;
          line-height: 32px;
          padding: 12px;
          .row {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;

            .left {
              flex: 0 0 auto;
              width: 100%;
              word-wrap: break-word;
              margin-bottom: 6px;
            }

            .right {
              flex: 0 0 auto;
              width: 100%;
              word-wrap: break-word;
              margin-bottom: 6px;
            }

            .single {
              flex: auto;
              margin-bottom: 6px;
            }
          }
        }

        // body-row
      }

      // .page-body
    }

    // .page-detail
  }
}

@media screen and (min-width: 320px) {
  .wrap {
    .wrapper {
      .curr-banner {
      }
    }
  }
}

@media screen and (min-width: 480px) {
  .wrap {
    .wrapper {
    }
  }
}
/* 移动 */
@media screen and (min-width: 576px) {
  .wrap {
    .wrapper {
      // curr-banner
      .curr-banner {
        height: 154px;

        ::v-deep {
          .el-carousel .img-item {
            display: block;
            height: 154px;
            width: 100%;
          }

          .el-carousel .el-carousel__container {
            height: 154px;
          }
        }
      }
      // curr-banner
    }
  }
}
/* 平板 */
@media screen and (min-width: 768px) {
  .wrap {
    .wrapper {
      // curr-banner
      .curr-banner {
        height: 204px;

        ::v-deep {
          .el-carousel .img-item {
            display: block;
            height: 204px;
            width: 100%;
          }

          .el-carousel__button {
            width: 30px;
          }

          .el-carousel .el-carousel__container {
            height: 204px;
          }
        }
      }
      // curr-banner

      // .page-detail
      .page-detail {
        background: #fff;

        .btn-group {
          .back-btn,
          .apply-btn {
            padding: 12px 20px;
          }

          .apply-btn {
            display: inline-block;
          }
        }

        // campus-cont
        .campus-cont {
          .info-wrap {
            .person,
            .date {
              width: 50%;
            }
          }
        }
        // campus-cont

        // .page-body
        .page-body {
          // body-row
          .body-row {
          }

          .row-body {
            font-size: 16px;
            // line-height: 32px;
            // padding: 12px;
            .row {
              // display: flex;
              // justify-content: space-between;
              // flex-wrap: wrap;

              .left {
                // flex: 0 0 auto;
                width: 50%;
                // word-wrap: break-word;
                margin-bottom: 12px;
              }

              .right {
                // flex: 0 0 auto;
                width: 50%;
                // word-wrap: break-word;
                margin-bottom: 12px;
              }

              .single {
                // flex: auto;
                margin-bottom: 12px;
              }
            }
          }

          // body-row
        }

        // .page-body
      }
      // .page-detail
    }
  }
}

/* PC */
@media screen and (min-width: 992px) {
  .wrap {
    .wrapper {
      // curr-banner
      .curr-banner {
        height: 260px;

        ::v-deep {
          .el-carousel .img-item {
            display: block;
            height: 260px;
            width: 100%;
          }

          .el-carousel .el-carousel__container {
            height: 260px;
          }
        }
      }
      // curr-banner
    }
  }
}
@media screen and (min-width: 1200px) {
  .wrap {
    .wrapper {
      padding-left: 0;
      padding-right: 0;
      // width: 1200px;
      margin: 0 auto;

      // curr-banner
      .curr-banner {
        height: 320px;

        ::v-deep {
          .el-carousel .img-item {
            display: block;
            height: 320px;
            width: 100%;
          }

          .el-carousel .el-carousel__container {
            height: 320px;
          }
        }
      }
      // curr-banner

      // page-detail
      .page-detail {
        width: 1200px;
        margin: 0 auto;
      }

      // page-detail
    }
  }
}
</style>
